import { createContext } from 'react';

import { AppReducerActionType, appReducerInitialState, IAppReducerState } from './AppReducer';

const AppContext = createContext<{app: IAppReducerState, dispatch: React.Dispatch<AppReducerActionType>}>({ app: appReducerInitialState, dispatch: () => {} });

export default AppContext;